import { render, staticRenderFns } from "./RegisterFormStudent.vue?vue&type=template&id=0d939c4d&scoped=true"
import script from "./RegisterFormStudent.vue?vue&type=script&lang=js"
export * from "./RegisterFormStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d939c4d",
  null
  
)

export default component.exports